import React, { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function Reset() {
  const [sp] = useSearchParams();
  const token = sp.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setErr('');
    if (password !== confirm) { setErr('Passwords do not match'); return; }
    if (password.length < 8) { setErr('Password must be 8+ chars'); return; }
    setBusy(true);
    try {
      await api.reset(token, password);
      nav('/login');
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  }

  return (
    <div className="auth-split">
      <div className="auth-left">
        <div className="auth-card">
          <div className="auth-brand"><Link to="/">Rivet</Link></div>
          <h1>Set a new password</h1>
          <form onSubmit={submit}>
            <label className="field"><span className="label">Password (8+ chars)</span>
              <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </label>
            <label className="field"><span className="label">Confirm</span>
              <input className="input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </label>
            {err && <div className="chip risk" style={{ marginBottom: 12 }}>{err}</div>}
            <button className="btn" style={{ width: '100%' }} disabled={busy || !token}>Save password</button>
          </form>
        </div>
      </div>
      <div className="auth-right" style={{ backgroundImage: `linear-gradient(135deg, rgba(24,29,76,0.6), rgba(24,29,76,0.4))` }}>
        <div className="auth-right-inner"><div className="kicker light">Rivet</div><h2>Reset complete in seconds.</h2></div>
      </div>
    </div>
  );
}
